module.exports = {
  en: {
    certificateNotification: {
      loading: "We will also try to send you the certificate by e-mail...",
      success: "The certificate was successfully sent by e-mail.",
      failure:
        "Unfortunately, the certificate could not be delivered by e-mail. Tip: Take a screenshot of your certificate to be on the safe side ;)",
    },
    certificateMail: `Hello {name},

Congratulations on passing the theory test {questionnaire} on {dt}. You will find your certificate attached to this email and in your exam app. Please send it together with all required documents to the office at least 15 days before the course begins.

Best wishes and good luck with the practical exam,
Your DSLV team`,
  },
  de: {
    certificateNotification: {
      loading:
        "Wir versuchen dir das Zertifikat zusätzlich per Mail zu senden...",
      success: "Das Zertifikat wurde erfolgreich per Mail versandt.",
      failure:
        "Leider konnte das Zertifkat nicht per Mail zugestellt werden. Tipp: Erstelle zur Sicherheit einen Screenshot von deinem Zertifikat ;)",
    },
    certificateMail: `Hallo {name},

herzlichen Glückwunsch zur bestandenen Theorieprüfung {questionnaire} am {dt}. Dein Zertifikat findest du im Anhang dieser Mail und in deiner Prüfungsapp. Bitte sende es gemeinsam mit allen weiteren Nachweisen spätestens 15 Tage vor Lehrgangsbeginn an die Geschäftsstelle.

Liebe Grüße und viel Erfolg bei der Praxis Prüfung,
Dein DSLV Team`,
  },
};
